import React from "react"
import types from "prop-types"
import { SidebarVisibilityControl } from "shared/Sidebar"
import ContentHeader from "shared/ContentHeader"

const AuditsHeader = ({ hiddenSidebar, toggleSidebar }) => (
  <ContentHeader
    leftElements={(
      <SidebarVisibilityControl
        className="hidden lg:flex"
        hiddenSidebar={hiddenSidebar}
        toggleSidebar={toggleSidebar}
      />
    )}
    heading={
      <h1 className="header-title">Audit Trail</h1>
    }
  />
)

AuditsHeader.propTypes = {
  hiddenSidebar: types.bool.isRequired,
  toggleSidebar: types.func.isRequired,
}

export default AuditsHeader
